const CART_QUERY_PREFIX = 'cart';
export const CART_QUERY_KEYS = {
	GUEST:       () => [ CART_QUERY_PREFIX, 'guest' ],
	MEMBER_ROOT: () => [ CART_QUERY_PREFIX, 'member' ],
	MEMBER:      (params: Record<string, unknown>) => [ CART_QUERY_PREFIX, 'member', params ],
};